#import "../../../mailbox/graphql/fragments/nut-email-address.graphql"
#import "../../../graphql/fragments/emailable-lead-fragment.graphql"

fragment ReplyableEmail on ReplyableEmail {
    bodyHtml
    subject
    replyAllAddresses {
        ...NutEmailAddress
    }
    replyToAddress {
        ...NutEmailAddress
    }
    relatedLeads {
        edges {
            node {
                ...EmailableLead
            }
            isMapped
        }
    }
}
